<section class="content-header">

    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">Add New Product</h1>
            </div>

        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</section>
<section class="content">
    <div class="container-fluid">
        <div class="card-body">
            <form [formGroup]="addProductForm" (ngSubmit)="saveProduct()">
            <div class="row">
            <div class="col-md-3 form-group">
            </div>
            <div class="col-md-6" class="form-group">
                <label style="font-weight:bold;width: 600px;">
                    Product Name :
                    <input type="text" 
                        class="form-control" formControlName="product"
                        >
                  
                </label>
                <div *ngIf="submitted && addProductForm.controls.product.errors" class="error">
                    <div *ngIf="addProductForm.controls.product.errors.required"
                        style="color:red">Product Name 
                        is required</div>
                </div>  
            </div>
            <div class="col-md-3 form-group">
            </div>
          </div>
            <div class="form-group" style="text-align: center;">
                <input type="submit" 
            value="Submit" class="btn btn-primary">
        </div>
        </form>
        <div class="row" *ngIf="productList.length>0" style="margin:10px;">
          <div class="col-md-2">
          </div>
          <div class="col-md-2">
          </div>
          <div class="col-md-4">
          </div>
          <div class="col-md-2">
            <input  type="text"  class="form-control" placeholder="search product " [(ngModel)]="productToSearch">
          </div>
          <div class="col-md-2">
            
            <input   type="button" value="Search" class="btn btn-primary"   (click)="searchProduct()"  style="width: 46%;margin-right: 3px;"  >
            <input   type="button" value="Reset" class="btn btn-primary"  style="width: 46%;"  (click)="resetParameter()">
          </div>

        </div>
        <div class="row" *ngIf="productListSearchFilter.length>0">
            <div class="table-responsive no-padding" >
              <table id="pmitter" class="table table-striped table-hover table-bordered">
                <thead>
                 

                </thead>
                <tbody>
                  <tr >
                    <th style="font-weight:bold;text-align: center; width: 5%;">S. No.</th>
                    <th style="font-weight:bold;text-align: center; width: 10%;">Product Name</th>
                    <!-- <th style="font-weight:bold; width: 10%;">District</th> -->
                    <!-- <th style="font-weight:bold; width: 5%;">MFTL Stations</th> -->
                    <!-- <th style="font-weight:bold; width: 10%;">Chasis No</th> -->
                    <!-- <th style="font-weight:bold; width: 10%;">Email</th>
                    <th style="font-weight:bold; width: 10%;">Mobile</th> -->
                    <!-- <th style="font-weight:bold; width: 10%;">Added/Updated On</th> -->
                    <!-- <th style="font-weight:bold; width: 10%;">Track Location</th> -->
                    <!-- <th style="font-weight:bold; width: 10%;">Capability</th> -->
                    <!-- <th style="font-weight:bold; width: 15%;">Manpower</th> -->
                    
                    <th style="font-weight:bold; text-align: center;width: 7%;">Action</th>
                  </tr>
                  <!-- <tr
                    *ngFor="let  product of productList | paginate : {itemsPerPage: 10, currentPage : p}; let i=index"> -->
                    <tr *ngFor="let  product of productListSearchFilter; let i=index" > 
                    <!-- <tr  *ngFor="let product of productList" > -->
                    <td style=" width: 5%;">{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                  
                    <td style=" width: 10%;">{{product.productName|titlecase}}</td>
                   
                  
                    <td style=" width: 7%; text-align: center;">
                      <input type="button"   value="Delete"
                      class="btn btn-danger btn-sm" (click)="deleteProduct(product.productId)">
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- <pagination-controls (pageChange)="p = $event" class="float-right"></pagination-controls> -->
            </div>
          </div>
        
       
    </div>
    </div>
</section>
